var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.674 1.822l10.505 1.852-1.852 10.505-10.505-1.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.902 4.457a.555.555 0 00-.785-.008l-6.378 6.234-1.407-2.011a.555.555 0 10-.91.637l1.782 2.546a.566.566 0 00.843.078l6.847-6.69a.555.555 0 00.008-.786z",
    fill: "#647A97"
  }))));
}
export default SvgIconBack;